import { COMMENT_NEW, COMMENT_OPEN } from '@BUP/constants'
import { message } from 'antd'
import { useTranslation } from 'react-i18next'
import { useQueryClient } from '@tanstack/react-query'
import { useApiMutation } from '@BUP/hooks/useApiMutation'

export const useChangeMessageState = () => {
  const [t] = useTranslation('translation', {
    keyPrefix: 'pages.modeBup.messageState'
  })

  const queryClient = useQueryClient()

  const mutation = useApiMutation(
    'schools',
    ({ messageId }) => `/bup-modes/${messageId}`,
    'patch',
    {
      onSuccess: (data, variables) => {
        const { messageId, newState } = variables
        const moveTo =
        newState === COMMENT_NEW || newState === COMMENT_OPEN
          ? t('text1')
          : t('text2')

        message.success(`${t('messageSuccess')} ${moveTo}.`, 2)

        queryClient.setQueryData(['bup-modes-messages'], previous => {
          if (!Array.isArray(previous)) return previous
          return previous.map(messageItem =>
            messageItem.id === messageId
              ? { ...messageItem, ...data }
              : messageItem
          )
        })
        queryClient.invalidateQueries(['bup-modes-messages'])
      },
      onError: (error) => {
        console.error(error)
        message.error(t('errorMessage'), 5)
      }
    }
  )

  return {
    data: mutation.data,
    isLoading: mutation.isPending,
    error: mutation.error ?? null,
    handleChangeMessageState: (messageId, value, newState) =>
      mutation.mutateAsync({
        messageId,
        newState,
        data: { state: newState, anonymus: value }
      })
  }
}
